import { formatUnits } from "viem";
import { AIAVAX_DECIMALS } from "./config";

const usdFormatter = new Intl.NumberFormat("zh-CN", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const tokenFormatter = new Intl.NumberFormat("zh-CN", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 6,
});

const rateFormatter = new Intl.NumberFormat("zh-CN", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 6,
});

export function bigintToNumber(value: bigint, decimals = AIAVAX_DECIMALS) {
  return Number(formatUnits(value, decimals));
}

export function formatToken(value: bigint, decimals = AIAVAX_DECIMALS) {
  return tokenFormatter.format(bigintToNumber(value, decimals));
}

export function formatUsd(value: number) {
  return Number.isFinite(value) ? usdFormatter.format(value) : "—";
}

export function formatRate(value: number) {
  return Number.isFinite(value) ? rateFormatter.format(value) : "—";
}

export function formatUtcDateTime(date: Date) {
  return new Intl.DateTimeFormat("zh-CN", {
    timeZone: "UTC",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(date) + " UTC";
}

export function formatMonth(date: Date) {
  return `${date.getUTCFullYear()} 年 ${date.getUTCMonth() + 1} 月`;
}

export function shortenHash(value: string, head = 6, tail = 4) {
  return `${value.slice(0, head)}…${value.slice(-tail)}`;
}

export function errorMessage(error: unknown) {
  if (error instanceof DOMException && error.name === "AbortError") {
    return "请求已取消";
  }
  return error instanceof Error ? error.message : "发生未知错误";
}
